import { ResponseStatus } from "src/types";

export type SelectionType = "pickUp" | "dropOff";

export interface RequestedPlace {
    address1: string;
    city: string;
    state: string;
    zip: string;
    latitude: number;
    longitude: number;
    name: string;
    description: string;
}

export interface TripRequestFormValues {
    clientID: number;
    importTripID: string;
    importClientID: string;
    utcOffset: number;
    clientFirstName: string;
    clientLastName: string;
    clientPhone: string;
    clientEmail: string;
    pickUpPlace: RequestedPlace;
    pickUpAddress2: string;
    dropOffPlace: RequestedPlace;
    dropOffAddress2: string;
    timeType: string;
    apptTime: Date;
    requestTime: Date;
    pickUpTime: Date;
    dropOffTime: Date;
    returnTime: Date;
    returnType: number;
    clientInWC: boolean;
    clientNeedsWCVan: boolean;
    clientWCType: string | null;
    clientIsDisabled: boolean;
    clientDisabilities: string;
    clientEquipment: string;
    personalCareAttendant: boolean;
    otherRiders: number;
    carSeatDescription: string;
    clientBirthdate: Date;
    clientComments: string;
    tripProgram: string;
    tripComments: string;
    tripSource: string;
    tripUrl: string;
    newPassword: string;
    clientRESTUrl: string;
    requesterEmail: string;
    recurrance: Recurrance;
}

export interface Recurrance {
    weekly: number;
    sunday: boolean;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
}

export interface TripRequest
    extends Omit<TripRequestFormValues | "pickUpPlace", "dropOffPlace"> {
    pickUpAddress: string;
    pickUpAddress2: string;
    pickUpCity: string;
    pickUpState: string;
    pickUpZipCode: string;
    pickUpLatitude: number;
    pickUpLongitude: number;
    pickUpPlaceName: string;
    pickUpAddressFull: string;
    dropOffAddress: string;
    dropOffAddress2: string;
    dropOffCity: string;
    dropOffState: string;
    dropOffZipCode: string;
    dropOffLatitude: number;
    dropOffAddressFull: string;
    dropOffLongitude: number;
    dropOffPlaceName: string;
    apptTimeEpoch: number;
    pickUpTimeEpoch: number;
    dropOffTimeEpoch: number;
    returnTimeEpoch: number;
}

export interface TripResponse extends ResponseStatus {
    AddedTrips: string[];
    ClientID: string;
    FailedTrips: any[];
    NewUserCreated: boolean;
}

export enum AutoScheduleStatus {
    success = "success",
    failed = "failed",
    pending = "pending",
}
